if (!customElements.get('belluce-cart-bogo')) {
  customElements.define('belluce-cart-bogo', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.track = this.querySelector('.belluce-bogo-track');
      if (!this.track.children.length) { this.hidden = true; return; }
      this.addEventListener('change', event => {
        event.stopPropagation();
        const select = event.target.closest('[data-bogo-variant]');
        if (select) select.closest('.belluce-bogo-card').querySelector('.belluce-bogo-price').textContent = select.selectedOptions[0].dataset.price;
      });
      this.addEventListener('click', event => {
        const arrow = event.target.closest('[data-bogo-scroll]');
        if (arrow) this.track.scrollBy({left:Number(arrow.dataset.bogoScroll) * this.track.clientWidth * 0.85,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
        const button = event.target.closest('[data-bogo-add]');
        if (button) this.addLamp(button);
      });
      this.rankRecommendations();
    }
    async rankRecommendations() {
      try {
        const url = new URL(this.dataset.recommendationsUrl + '.json', location.origin);
        url.searchParams.set('product_id', this.dataset.productId);
        url.searchParams.set('limit', '10');
        url.searchParams.set('intent', 'related');
        const response = await fetch(url);
        if (!response.ok) return;
        const data = await response.json();
        if (!this.isConnected || this.busy) return;
        const cards = Array.from(this.track.children);
        const ranked = (data.products || []).map(product => cards.find(card => card.dataset.productId === String(product.id))).filter(Boolean);
        const ordered = [...new Set([...ranked, ...cards])].slice(0, 10);
        this.track.replaceChildren(...ordered);
      } catch (_) {}
    }
    async addLamp(button) {
      if (this.busy) return;
      this.busy = true;
      const buttons = this.querySelectorAll('[data-bogo-add]');
      buttons.forEach(item => item.disabled = true);
      const error = this.querySelector('.belluce-bogo-error');
      error.textContent = '';
      let added = false;
      try {
        const drawer = this.closest('cart-drawer');
        const variant = button.closest('.belluce-bogo-card').querySelector('[data-bogo-variant]')?.value || button.dataset.bogoAdd;
        const response = await fetch(this.dataset.addUrl + '.js', {
          method: 'POST',
          headers: {'Content-Type':'application/json','Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
          body: JSON.stringify({items:[{id:variant,quantity:1}],...(drawer ? {sections:drawer.getSectionsToRender().map(section=>section.id),sections_url:location.pathname} : {})})
        });
        const data = await response.json();
        if (!response.ok || data.status) throw new Error(data.description || this.dataset.error);
        added = true;
        if (!drawer) { document.dispatchEvent(new CustomEvent('maison:cart-added')); return; }
        if (!data.sections || Object.values(data.sections).some(section => !section)) { location.reload(); return; }
        drawer.setActiveElement(document.getElementById('cart-icon-bubble'));
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        requestAnimationFrame(() => drawer.querySelector('.drawer__close')?.focus());
      } catch (exception) {
        if (added) { location.reload(); return; }
        error.textContent = exception.message || this.dataset.error;
        buttons.forEach(item => item.disabled = false);
        this.busy = false;
      }
    }
  });
}

